export default "__VITE_ASSET__V2nSjLCS__"